export const homeDataConstants = {

	SET_TOKENS:"SET_TOKENS",

	SHOW_ADD_MENU_MODAL: "SHOW_ADD_MENU_MODAL",
	HIDE_ADD_MENU_MODAL: "HIDE_ADD_MENU_MODAL",

	GET_QR_REQUEST: "GET_QR_REQUEST",
	GET_QR_SUCCESS: "GET_QR_SUCCESS",
	GET_QR_FAILURE: "GET_QR_FAILURE",

	LOCK_CHANGE_SUCCESS: "LOCK_CHANGE_SUCCESS",
	LOCK_CHANGE_FAILURE: "LOCK_CHANGE_FAILURE",

	
	LOADING_START: "LOADING_START",
	LOADING_END: "LOADING_END",

	DATA_TOUR_POINTS_GET_REQUEST: "DATA_TOUR_POINTS_GET_REQUEST",
	DATA_TOUR_POINTS_GET_FAILURE: "DATA_TOUR_POINTS_GET_FAILURE",
	DATA_TOUR_POINTS_GET_SUCCESS: "DATA_TOUR_POINTS_GET_SUCCESS",


	DATA_TOUR_POINTS_GET_UPDATE_FAILURE: "DATA_TOUR_POINTS_GET_UPDATE_FAILURE",
	DATA_TOUR_POINTS_GET_UPDATE_SUCCESS: "DATA_TOUR_POINTS_GET_UPDATE_SUCCESS",


	PREVIOUS_DATA_GET_REQUEST: "PREVIOUS_DATA_GET_REQUEST",
	PREVIOUS_DATA_GET_FAILURE: "PREVIOUS_DATA_GET_FAILURE",
	PREVIOUS_DATA_GET_SUCCESS: "PREVIOUS_DATA_GET_SUCCESS",


	TOUR_SUBMIT_REQUEST: "TOUR_SUBMIT_REQUEST",
	TOUR_SUBMIT_SUCCESS: "TOUR_SUBMIT_SUCCESS",
	TOUR_SUBMIT_FAILURE: "TOUR_SUBMIT_FAILURE",

	PARTNER_SUBMIT_REQUEST: "PARTNER_SUBMIT_REQUEST",
	PARTNER_SUBMIT_SUCCESS: "PARTNER_SUBMIT_SUCCESS",
	PARTNER_SUBMIT_FAILURE: "PARTNER_SUBMIT_FAILURE",

	TOUR_UPDATE_REQUEST: "TOUR_UPDATE_REQUEST",
	TOUR_UPDATE_SUCCESS: "TOUR_UPDATE_SUCCESS",
	TOUR_UPDATE_FAILURE: "TOUR_UPDATE_FAILURE",


	POI_UPDATE_REQUEST: "POI_UPDATE_REQUEST",
	POI_UPDATE_SUCCESS: "POI_UPDATE_SUCCESS",
	POI_UPDATE_FAILURE: "POI_UPDATE_FAILURE",

	HIDE_ADD_MODAL: "HIDE_ADD_MODAL",
	SHOW_ADD_MODAL: "SHOW_ADD_MODAL",

	HIDE_ADD_PARTNER_MODAL: "HIDE_ADD_PARTNER_MODAL",
	SHOW_ADD_PARTNER_MODAL: "SHOW_ADD_PARTNER_MODAL",

	HIDE_MODAL: "HIDE_MODAL",
	SHOW_MODAL: "SHOW_MODAL",

	SUCCESS_MODAL_SHOW: "SUCCESS_MODAL_SHOW",
	SUCCESS_MODAL_HIDE: "SUCCESS_MODAL_HIDE",


	HIDE_TERMS_AND_CONDITIONS_MODAL: "HIDE_TERMS_AND_CONDITIONS_MODAL",
	SHOW_TERMS_AND_CONDITIONS_MODAL: "SHOW_TERMS_AND_CONDITIONS_MODAL",


	FAILURE_MODAL_SHOW: "FAILURE_MODAL_SHOW",
	FAILURE_MODAL_HIDE: "FAILURE_MODAL_HIDE",


	GET_BPARTNERS_REQUEST: "GET_BPARTNERS_REQUEST",
	GET_BPARTNERS_SUCCESS: "GET_BPARTNERS_SUCCESS",
	GET_BPARTNERS_FAILURE: "GET_BPARTNERS_FAILURE",


	UPDATE_MENU_PHOTO_SUCCESS: "UPDATE_MENU_PHOTO_SUCCESS",
	UPDATE_MENU_PHOTO_FAILURE: "UPDATE_MENU_PHOTO_FAILURE",

	HIDE_SUCCESS_FAILURE_MODAL: "HIDE_SUCCESS_FAILURE_MODAL",


	INSERT_DATA_SUCCESS: "INSERT_DATA_SUCCESS",
	INSERT_DATA_FAILURE: "INSERT_DATA_FAILURE",

	UPDATE_TOUR_DATA_MODAL_SHOW: "UPDATE_TOUR_DATA_MODAL_SHOW",
	UPDATE_TOUR_DATA_MODAL_CLOSE: "UPDATE_TOUR_DATA_MODAL_CLOSE",


	UPDATE_POINT_DATA_MODAL_SHOW: "UPDATE_POINT_DATA_MODAL_SHOW",
	UPDATE_POINT_DATA_MODAL_CLOSE: "UPDATE_POINT_DATA_MODAL_CLOSE",

	DELETE_TOUR_REQUEST: "DELETE_TOUR_REQUEST",
	DELETE_TOUR_SUCCESS: "DELETE_TOUR_SUCCESS",
	DELETE_TOUR_FAILURE: "DELETE_TOUR_FAILURE",


	SHOW_UPDATE_LOGO_MODAL: "SHOW_UPDATE_LOGO_MODAL",
	HIDE_UPDATE_LOGO_MODAL: "HIDE_UPDATE_LOGO_MODAL",


	UPDATE_LOGO_PHOTO_SUCCESS: "UPDATE_LOGO_PHOTO_SUCCESS",
	UPDATE_LOGO_PHOTO_FAILURE: "UPDATE_LOGO_PHOTO_FAILURE",

	SHOW_CHANGE_LOCK_CODE_MODAL: "SHOW_CHANGE_LOCK_CODE_MODAL",
	HIDE_CHANGE_LOCK_CODE_MODAL: "HIDE_CHANGE_LOCK_CODE_MODAL",

	GET_TERMS_AND_CONSITIONS_REQUEST: "GET_TERMS_AND_CONSITIONS_REQUEST",
	GET_TERMS_AND_CONSITIONS_SUCCESS: "GET_TERMS_AND_CONSITIONS_SUCCESS",
	GET_TERMS_AND_CONSITIONS_FAILURE: "GET_TERMS_AND_CONSITIONS_FAILURE",

	CONFIRMATION_REQUEST: "CONFIRMATION_REQUEST",
	CONFIRMATION_SUCCESS: "CONFIRMATION_SUCCESS",
	CONFIRMATION_FAILURE: "CONFIRMATION_FAILURE",

	GET_QRCODES_REQUEST: "GET_QRCODES_REQUEST",
	GET_QRCODES_SUCCESS: "GET_QRCODES_SUCCESS",
	GET_QRCODES_FAILURE: "GET_QRCODES_FAILURE",

	GENERATE_QRCODE_REQUEST: "GENERATE_QRCODE_REQUEST",
	GENERATE_QRCODE_SUCCESS: "GENERATE_QRCODE_SUCCESS",
	GENERATE_QRCODE_FAILURE: "GENERATE_QRCODE_FAILURE",
	
	SHOW_ADD_QR_CODE_MODAL: "SHOW_ADD_QR_CODE_MODAL",
	HIDE_ADD_QR_CODE_MODAL: "HIDE_ADD_QR_CODE_MODAL",

	HIDE_EDIT_LOGO_MODAL: "HIDE_EDIT_LOGO_MODAL",

	DELETE_POI_SUCCESS: "DELETE_POI_SUCCESS",
	DELETE_POI_FAILURE: "DELETE_POI_FAILURE",

	
	CHANGE_LOCK_CODE_REQUEST: "CHANGE_LOCK_CODE_REQUEST",
	CHANGE_LOCK_CODE_SUCCESS: "CHANGE_LOCK_CODE_SUCCESS",
	CHANGE_LOCK_CODE_FAILURE: "CHANGE_LOCK_CODE_FAILURE",

	
	
	APPROVE_REQUEST: "APPROVE_REQUEST",
	APPROVE_SUCCESS: "APPROVE_SUCCESS",
	APPROVE_FAILURE: "APPROVE_FAILURE",

	
	DISAPPROVE_REQUEST: "DISAPPROVE_REQUEST",
	DISAPPROVE_SUCCESS: "DISAPPROVE_SUCCESS",
	DISAPPROVE_FAILURE: "DISAPPROVE_FAILURE",

	ADD_GPX_MODAL_SHOW: "ADD_GPX_MODAL_SHOW",
	ADD_GPX_MODAL_HIDE: "ADD_GPX_MODAL_HIDE",

	ADD_GPX_REQUEST: "ADD_GPX_REQUEST",
	ADD_GPX_SUCCESS: "ADD_GPX_SUCCESS",
	ADD_GPX_FAILURE: "ADD_GPX_FAILURE",

	
	ADD_TEASER_REQUEST: "ADD_TEASER_REQUEST",
	ADD_TEASER_SUCCESS: "ADD_TEASER_SUCCESS",
	ADD_TEASER_FAILURE: "ADD_TEASER_FAILURE",

	
	SEARCH_REQUEST: "SEARCH_REQUEST",
	SEARCH_SUCCESS: "SEARCH_SUCCESS",
	SEARCH_FAILURE: "SEARCH_FAILURE",

	CLOSE_VIDEO: "CLOSE_VIDEO",

	
	SEND_DEMO_REQUEST: "SEND_DEMO_REQUEST",
	SEND_DEMO_SUCCESS: "SEND_DEMO_SUCCESS",
	SEND_DEMO_FAILURE: "SEND_DEMO_FAILURE",

	
	CHANGE_API_REQUEST: "CHANGE_API_REQUEST",
	CHANGE_API_SUCCESS: "CHANGE_API_SUCCESS",
	CHANGE_API_FAILURE: "CHANGE_API_FAILURE",

	
	GET_VIDEOS_REQUEST: "GET_VIDEOS_REQUEST",
	GET_VIDEOS_SUCCESS: "GET_VIDEOS_SUCCESS",
	GET_VIDEOS_FAILURE: "GET_VIDEOS_FAILURE",

	
	GET_TOUR_LIBRARY_REQUEST: "GET_TOUR_LIBRARY_REQUEST",
	GET_TOUR_LIBRARY_SUCCESS: "GET_TOUR_LIBRARY_SUCCESS",
	GET_TOUR_LIBRARY_FAILURE: "GET_TOUR_LIBRARY_FAILURE",
	
	GET_FAMOUS_PEOPLE_REQUEST: "GET_FAMOUS_PEOPLE_REQUEST",
	GET_FAMOUS_PEOPLE_SUCCESS: "GET_FAMOUS_PEOPLE_SUCCESS",
	GET_FAMOUS_PEOPLE_FAILURE: "GET_FAMOUS_PEOPLE_FAILURE",

	
	GET_STORY_REQUEST: "GET_STORY_REQUEST",
	GET_STORY_SUCCESS: "GET_STORY_SUCCESS",
	GET_STORY_FAILURE: "GET_STORY_FAILURE",

	
	GET_POIS_REQUEST: "GET_POIS_REQUEST",
	GET_POIS_SUCCESS: "GET_POIS_SUCCESS",
	GET_POIS_FAILURE: "GET_POIS_FAILURE",

	
	GET_ADDS_REQUEST: "GET_ADDS_REQUEST",
	GET_ADDS_SUCCESS: "GET_ADDS_SUCCESS",
	GET_ADDS_FAILURE: "GET_ADDS_FAILURE",

	
	
	GET_PROMPT_REQUEST: "GET_PROMPT_REQUEST",
	GET_PROMPT_SUCCESS: "GET_PROMPT_SUCCESS",
	GET_PROMPT_FAILURE: "GET_PROMPT_FAILURE",

	
	UPDATE_ADDS_REQUEST: "UPDATE_ADDS_REQUEST",
	UPDATE_ADDS_SUCCESS: "UPDATE_ADDS_SUCCESS",
	UPDATE_ADDS_FAILURE: "UPDATE_ADDS_FAILURE",

	
	GET_CREATE_TOUR_VIDEO_REQUEST: "GET_CREATE_TOUR_VIDEO_REQUEST",
	GET_CREATE_TOUR_VIDEO_SUCCESS: "GET_CREATE_TOUR_VIDEO_SUCCESS",
	GET_CREATE_TOUR_VIDEO_FAILURE: "GET_CREATE_TOUR_VIDEO_FAILURE",

	
	GET_PATMENT_LINK_REQUEST: "GET_PATMENT_LINK_REQUEST",
	GET_PATMENT_LINK_SUCCESS: "GET_PATMENT_LINK_SUCCESS",
	GET_PATMENT_LINK_FAILURE: "GET_PATMENT_LINK_FAILURE",

	GET_TOUR_NAME_REQUEST: "GET_TOUR_NAME_REQUEST",
	GET_TOUR_NAME_SUCCESS: "GET_TOUR_NAME_SUCCESS",
	GET_TOUR_NAME_FAILURE: "GET_TOUR_NAME_FAILURE",

	UPDATE_STORY_CHAPTER: 'UPDATE_STORY_CHAPTER',

	SEND_DEMO_LOADING_DONE: 'SEND_DEMO_LOADING_DONE',
	SEND_DEMO_LOADING_CLOSE: 'SEND_DEMO_LOADING_CLOSE',
	GO_BACK: "GO_BACK",

	TOGGLE_EDIT: 'TOGGLE_EDIT',
	UPDATE_LOCATION: 'UPDATE_LOCATION',
	
	START_DRAG: 'START_DRAG',
	END_DRAG: 'END_DRAG',





};
